import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardService } from '../dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService implements OnDestroy {

    constructor(
        private dashboardService: DashboardService,
    ) {}

    ngOnDestroy() {}

    public getCurrentLocation(): Observable<{lat: number, lng: number}> {
        this.dashboardService.spin$.next(true);
        return new Observable((observer) => {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const coords = position.coords;
                    const result = {
                        lat: coords.latitude,
                        lng: coords.longitude
                    };

                    observer.next(result);
                    observer.complete();
                },
                error => {
                    observer.error(error);
                    observer.complete();
                },
                {
                    enableHighAccuracy: true
                });
        });
    }
}
